import PropTypes from 'prop-types';

import {THEMES} from '@asdf-constants';

export const Props = {
  /**
   * The theme of the divider
   */
  theme: PropTypes.oneOf(Object.values(THEMES)),
  /**
   * Give the card a specific ID
   */
  id: PropTypes.string,
  /**
   * Give the card a fixed width
   */
  width: PropTypes.any,
  /**
   * Give the card a fixed height
   */
  height: PropTypes.any,
  /**
   * If true, the height of the card stretches to 100% of the container
   */
  fullheight: PropTypes.bool,
  /**
   * If true, the card has no rounded corners
   */
  square: PropTypes.bool,
  /**
   * If true, the card has no border
   */
  noBorder: PropTypes.bool,
  /**
   * If true, the card has smaller inner padding
   */
  narrow: PropTypes.bool,
  /**
   * If true, the card has no inner padding
   */
  dense: PropTypes.bool,
  /**
   * If true, the card has no box-shadow
   */
  flat: PropTypes.bool,
  /**
   * If true, the card has a subtle box-shadow
   */
  raised: PropTypes.bool,
  /**
   * If true, the card is displayed as a placeholder
   */
  isPlaceholder: PropTypes.bool,
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
